import React, { useState } from 'react';
import { Mail, Phone, Send, Flame } from 'lucide-react';
import { Card } from './ui/card';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';
import { toast } from 'sonner';

export const Contact = ({ contactInfo }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Mock form submission
    if (formData.name && formData.email && formData.message) {
      toast.success('Mensagem enviada com sucesso! 🔥', {
        description: 'Entraremos em contato em breve.'
      });
      setFormData({ name: '', email: '', message: '' });
    } else {
      toast.error('Por favor, preencha todos os campos!');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="relative py-24 bg-gradient-to-b from-black via-zinc-900 to-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="h-px w-12 bg-red-600"></div>
            <Flame className="w-8 h-8 text-red-600" />
            <div className="h-px w-12 bg-red-600"></div>
          </div>
          <h2 className="text-5xl sm:text-6xl font-black text-white mb-6 tracking-tight">
            CONTATO
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Entre em contato para comprar ou se tornar um revendedor
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-5 gap-8">
            {/* Contact Information */}
            <div className="lg:col-span-2 space-y-6">
              <Card className="bg-gradient-to-br from-zinc-900 to-black border-2 border-red-600 p-8 hover:shadow-xl hover:shadow-red-600/20 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-red-950/50 rounded-lg flex items-center justify-center border-2 border-red-600 flex-shrink-0">
                    <Mail className="w-7 h-7 text-red-500" />
                  </div>
                  <div>
                    <h3 className="text-xl font-black text-white mb-2">EMAIL</h3>
                    <a
                      href={`mailto:${contactInfo.email}`}
                      className="text-gray-300 hover:text-red-500 transition-colors duration-300 break-all"
                    >
                      {contactInfo.email}
                    </a>
                  </div>
                </div>
              </Card>

              <Card className="bg-gradient-to-br from-zinc-900 to-black border-2 border-red-600 p-8 hover:shadow-xl hover:shadow-red-600/20 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 bg-red-950/50 rounded-lg flex items-center justify-center border-2 border-red-600 flex-shrink-0">
                    <Phone className="w-7 h-7 text-red-500" />
                  </div>
                  <div>
                    <h3 className="text-xl font-black text-white mb-2">TELEFONE</h3>
                    <a
                      href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                      className="text-gray-300 hover:text-red-500 transition-colors duration-300"
                    >
                      {contactInfo.phone}
                    </a>
                  </div>
                </div>
              </Card>

              {/* Decorative Card */}
              <Card className="bg-gradient-to-br from-red-950/30 to-black border-2 border-red-600 p-8">
                <div className="text-center">
                  <Flame className="w-16 h-16 text-red-600 mx-auto mb-4 animate-pulse" />
                  <h3 className="text-2xl font-black text-white mb-3">
                    SEJA UM REVENDEDOR
                  </h3>
                  <p className="text-gray-300">
                    Traga o Rasputin para sua região e lucre com o molho mais intenso do mercado!
                  </p>
                </div>
              </Card>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-3">
              <Card className="bg-gradient-to-br from-zinc-900 to-black border-2 border-red-600 p-8 sm:p-10">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label className="block text-white font-bold mb-2">
                      NOME *
                    </label>
                    <Input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Seu nome completo"
                      required
                      className="bg-zinc-800 border-red-900/50 text-white placeholder:text-gray-500 focus:border-red-600 h-12"
                    />
                  </div>

                  <div>
                    <label className="block text-white font-bold mb-2">
                      EMAIL *
                    </label>
                    <Input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="seu@email.com"
                      required
                      className="bg-zinc-800 border-red-900/50 text-white placeholder:text-gray-500 focus:border-red-600 h-12"
                    />
                  </div>

                  <div>
                    <label className="block text-white font-bold mb-2">
                      MENSAGEM *
                    </label>
                    <Textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Conte-nos como podemos ajudar..."
                      required
                      rows={6}
                      className="bg-zinc-800 border-red-900/50 text-white placeholder:text-gray-500 focus:border-red-600 resize-none"
                    />
                  </div>

                  <Button
                    type="submit"
                    className="w-full bg-red-600 hover:bg-red-700 text-white font-black text-lg py-6 shadow-xl shadow-red-600/50 transition-all duration-300 hover:shadow-red-600/80 hover:scale-105"
                  >
                    <Send className="w-5 h-5 mr-2" />
                    ENVIAR MENSAGEM
                  </Button>
                </form>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
